import { render, staticRenderFns } from "./GridStrategy.vue?vue&type=template&id=1fee7cad&"
import script from "./GridStrategy.vue?vue&type=script&lang=ts&"
export * from "./GridStrategy.vue?vue&type=script&lang=ts&"
import style0 from "./GridStrategy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports